import React from 'react';

function AboutPage() {
  return (
    <div className="bg-white p-8 rounded-lg shadow-md">
      <h1 className="text-3xl font-bold text-brand-green mb-4">Hakkımızda</h1>
      <p className="text-text-dark leading-relaxed">
        Minela Kids'e hoş geldiniz! Biz, çocuklar için en kaliteli, en şık ve en rahat kıyafetleri tasarlamak ve üretmek için yola çıkmış bir ekibiz. 
        Her bir ürünümüzü kendi çocuklarımıza giydireceğimiz özenle seçiyor ve sevgiyle hazırlıyoruz.
        <br /><br />
        Felsefemiz, çocukların özgürce hareket edebileceği, oyun oynarken kendilerini rahat hissedebileceği ve aynı zamanda şıklıklarından ödün vermeyeceği tasarımlar sunmaktır. 
        Kumaşlarımızın kalitesine, dikişlerin sağlamlığına ve tasarımlarımızın özgünlüğüne büyük önem veriyoruz.
        <br /><br />
        Minela Kids ailesi olarak, minik kahramanların dünyasına renk katmaktan mutluluk duyuyoruz.
      </p>
    </div>
  );
}

export default AboutPage;
